import api from "../axios";

export async function getProdutos(
  page = 1,
  perPage = 10000,
  needle,
  admin = false,
  tipo = null
) {
  try {
    const params = { page, perPage, needle };
    if (tipo) params.tipo = tipo;
    const response = await api.get(
      admin ? "/products/all-admin" : "/products/all",
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch products:", error);
    throw error;
  }
}

export async function getProduto(id) {
  try {
    const response = await api.get(`/products/one/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch product:", error);
    throw error;
  }
}

export async function createProduto(produto) {
  try {
    /*
    {
    "id_everest": "1234",
    "nome": "Cadeira de praia amarela",
    "preco": 100,
    "imagens": [
        "link1"
    ],
    "videos": [],
    "descricao": "descricao em html",
    "status": "active",
    "destaque": false
}
    */
    const response = await api.post("/products", produto);
    return response.data;
  } catch (error) {
    console.error("Failed to create product:", error);
    throw error;
  }
}

export async function updateProduto(product) {
  const productId = product.id;
  /*
  {
    "nome": "Cadeira de praia amarela",
    "preco": 100,
    "imagens": [
        "link1"
    ],
    "videos": [],
    "descricao": "descricao em html",
    "destaque": false
}*/
  // put em products/:id
  try {
    const response = await api.put(`/products/${productId}`, product);
    return response.data;
  } catch (error) {
    console.error("Failed to update product:", error);
    throw error;
  }
}

export async function setProcutStatus(id, status) {
  // post {{BASE_URL}}/products/change-status/:id
  const payload = { status };
  try {
    const response = await api.post(`/products/change-status/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Failed to change product status:", error);
    throw error;
  }
}

export async function deleteProduto(id) {
  try {
    const response = await api.delete(`/products/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete product:", error);
    throw error;
  }
}

// Variantes
export async function getProductVariants(id) {
  const response = await api.get(`/products/${id}/variants`);
  return response.data;
}

export async function createProductVariant(id_product, variant) {
  const response = await api.post(`/products/${id_product}/variants`, variant);
  return response.data;
}

export async function updateProductVariant(variantId, variant) {
  const response = await api.put(`/products/variants/${variantId}`, variant);
  return response.data;
}

export async function deleteProductVariant(variantId) {
  const response = await api.delete(`/products/variants/${variantId}`);
  return response.data;
}

// Tipos de atributo
export async function getAttributeTypes() {
  const response = await api.get(`/products/attribute-types`);
  return response.data;
}

export async function createAttributeType(nome) {
  const response = await api.post(`/products/attribute-types`, { nome });
  return response.data;
}

export async function deleteAttributeType(id) {
  const response = await api.delete(`/products/attribute-types/${id}`);
  return response.data;
}

export async function getAttributeValues() {
  const response = await api.get(`/products/attribute-values`);
  return response.data;
}

// Notificacao "Me avise quando disponivel"
export async function notifyWhenAvailable(id_product) {
  const response = await api.post(`/products/${id_product}/notify`);
  return response.data;
}

export async function getMyNotifications() {
  const response = await api.get(`/products/notifications/me`);
  return response.data;
}

export async function removeNotification(id) {
  const response = await api.delete(`/products/notifications/${id}`);
  return response.data;
}

export async function getProductInterested(id_product, tipo) {
  const response = await api.get(`/products/${id_product}/notifications`, {
    params: { tipo },
  });
  return response.data;
}